<template>
    <div
        class="col-12 col-lg-6 col-md-6 position-relative p-0 px-1"
        v-for="(item, index) in list" :key="index"
    >
        <SelectDesign
            :label="item.optionName"
            :bgColor="bgColor"
            v-model="selectOption[item.optionName]"
            :list="item.values"
            :option="item"
        />
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    // label: {
    //     type: String,
    //     default: ""
    // },
    list: {
        type: Array,
        default: ()=> [{
            id: 0,
            name: "Select One"
        }]
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const data = useVModel(props, emit, "modelValue");
// const selectOption = ref(null);
const selectOption = ref({});
watch(selectOption,
    (newVal) => {
        if (selectOption.value) {
            Object.keys(selectOption.value).forEach(key => {
                if (!selectOption.value[key].selected) {
                    let index = data.value.findIndex(i => i.optionName == selectOption.value[key].optionName && i.optionId == selectOption.value[key].optionId);
                    if (index > -1) {
                        data.value[index] = selectOption.value[key];
                    } else {
                        data.value.push(selectOption.value[key]);
                    }
                }
            });
        }
    },
    { immediate: true, deep: true }
);

watch(() => props.list,
    (newVal) => {
        if (props.list?.length) {
            props.list.forEach(element => {
                // console.log(element.optionName);
                // if (selectedOptions.value != null) {
                //     console.log(Object.keys(selectedOptions.value))
                // }
                selectOption.value[element.optionName] = null;
                // selectOption.value[element.optionName] = {id: "selectOne", name: "Select One"};
                selectOption.value[element.optionName] = props.list.filter(i => i.optionName == element.optionName)[0]?.values[0];
                // console.log("selectedOptions.value");
                // console.log(selectedOptions.value);
            });
        }
    },
    { immediate: true, deep: true }
);


</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}


.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>